import React, { useEffect, useState } from "react";
import back from "../../Asset/product/back.png";
import Wallethistory from "../../component/wallethistory/Wallethistory";
import { useLocation } from "react-router-dom";
import wallet from "../../Asset/wallet/wallet.png"
import { FaCircle } from "react-icons/fa";

const Wallet = () => {
  const [wallethistory, setWallethistory] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));
const location = useLocation();


    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location?.pathname]);
  return (
    <div
  className="w-full pb-48 pt-32 pl-12 pr-12"
  style={{
    backgroundImage: `url(${back})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  }}
>
      <div className="">
        <div>
          <span className="text-2xl text-textColor font-semibold title1">
            Sehatful Wallet
          </span>
        </div>
        <div className="w-full mt-20 flex flex-col md:flex-row">
          <div className="w-1/2 flex flex-col mt-3">
            <span className="text-2xl md:text-6xl font-bold title2">
              ₹ {user && user?.wallet_balance}
            </span>
            <span className="text-xl title2 md:text-4xl text-textColor font-bold mt-8">
              Total Balance
            </span>
          </div>
          <div className=" w-full md:w-1/2">
            <div className="mt-10 md:mt-0">
              <span className="title2 text-xl md:text-2xl font-bold text-textColor ">
                Add Balance
              </span>
            </div>
            <div className="full mt-9">
              <div className=" w-full md:w-4/5 p-1 bg-white rounded-xl">
              <div className="py-2 px-4  flex items-center gap-2">
                <img src={wallet} alt="" className="w-7 h-6"/>
                <input
                  type="number"
                  className="w-full border-none outline-none"
                  placeholder="Enter Amount"
                />
              </div>
                
              </div>
            </div>
            <div className="w-full mt-9 ">
              <button className="w-full title2 md:w-4/5 bg-textColor text-white py-3 rounded-4xl text-lg font-bold" >
                Proceed To Add
              </button>
            </div>
            <div className="w-full mt-9 ">
              <button className="w-full title2 md:w-4/5 border-2 border-textColor text-textColor  py-3 rounded-4xl text-[13px] font-bold" onClick={()=>{
                setWallethistory(true);
              }}>
                View Transaction History
              </button>
            </div>
          </div>
        </div>
        <div className="w-full  mt-20 mb-10">
          <span className="text-textColor text-xl title2 font-semibold">
            Please Note:
          </span>
          <div className="flex flex-col mt-5">
            <span className="flex gap-2 items-center text-[#595959] title2 text-[14px]">
             <FaCircle className="text-[5px] "/>You can use wallet balance to make a purchase  on SEHATFUL Website/App on</span>
             
            <span className="flex gap-2 text-[#595959] items-center title2 text-[14px] mt-2">  <FaCircle className="text-[5px] "/> Your money is 100% safe with us.</span>
          </div>
        </div>
      </div>
      {wallethistory && <Wallethistory wallethistory={wallethistory} setWallethistory={setWallethistory}/>}
    </div>
  );
};

export default Wallet;
